import { useMemo } from 'react';
import { useSyncStaticStateInsideIFrame } from 'embedded-academy-lib/insideFrame';
import useSearchParams from 'academy-common-lib/hooks/useSearchParams';
import { getIsStaticPublicUrl } from '../../utils/urls';
export const useStaticContentState = () => {
  const {
    state
  } = useSyncStaticStateInsideIFrame();
  const [searchParams] = useSearchParams();
  const shouldEnablePictureInPicture = useMemo(() => searchParams.enablePictureInPicture ? /^true$/i.test(searchParams.enablePictureInPicture) : undefined, [searchParams.enablePictureInPicture]);
  if (getIsStaticPublicUrl() && !state) {
    return {
      authType: 'public',
      shortId: searchParams.shortId && Number(searchParams.shortId) || undefined,
      lessonId: searchParams.lessonId && Number(searchParams.lessonId) || undefined,
      contentId: searchParams.contentId && Number(searchParams.contentId) || undefined,
      language: searchParams === null || searchParams === void 0 ? void 0 : searchParams.language,
      variant: searchParams === null || searchParams === void 0 ? void 0 : searchParams.variant,
      startTime: searchParams === null || searchParams === void 0 ? void 0 : searchParams.startTime,
      Link: undefined,
      Title: undefined,
      Description: undefined,
      renderContext: searchParams.renderContext,
      hublet: searchParams.hublet,
      enablePictureInPicture: shouldEnablePictureInPicture
    };
  }
  return Object.assign({
    authType: state === null || state === void 0 ? void 0 : state.authType,
    shortId: state === null || state === void 0 ? void 0 : state.shortId,
    lessonId: state === null || state === void 0 ? void 0 : state.lessonId,
    contentId: state === null || state === void 0 ? void 0 : state.contentId,
    language: state === null || state === void 0 ? void 0 : state.language,
    variant: state === null || state === void 0 ? void 0 : state.variant,
    startTime: state === null || state === void 0 ? void 0 : state.startTime,
    renderContext: state === null || state === void 0 ? void 0 : state.renderContext,
    enablePictureInPicture: state === null || state === void 0 ? void 0 : state.enablePictureInPicture,
    hublet: state === null || state === void 0 ? void 0 : state.hublet
  }, (state === null || state === void 0 ? void 0 : state.Link) && {
    Link: state.Link
  }, (state === null || state === void 0 ? void 0 : state.Title) && {
    Title: state.Title
  }, (state === null || state === void 0 ? void 0 : state.Description) && {
    Description: state.Description
  });
};